<template>
  <el-form
    :model="form"
    ref="form">
    <div class="row">
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('subject')"
          prop="remarkSubjectID"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <select-response
            :model.sync="form.remarkSubjectID"
            @on-change="updateModelItem('remarkSubjectID', { required: true })"
            :isLoading="dataSourceCompanyRemarkSubject.loading"
            :data="dataSourceCompanyRemarkSubject.records"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('followup-date')"
          prop="followupDate"
          class="material-style"
        >
          <date-picker
            v-model="form.followupDate"
            @change="updateModelItem('followupDate', { required: false })"
          ></date-picker>
        </el-form-item>
      </div>
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('followup-person')"
          prop="followupPerson"
          class="material-style"
        >
          <el-input
            v-model="form.followupPerson"
            @change="updateModelItem('followupPerson', { required: false })"
          />
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <el-form-item
          :label="L10n('remark')"
          prop="remark"
          class="material-style">
          <el-input
            type="textarea"
            :value="form.remark"
            @input="form.remark = valueTrimLeft($event)"
            @change="updateModelItem('remark', { required: false })"/>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormSpecialInstructionNew',
  mixins: [Form],
  computed: {
    dataSourceCompanyRemarkSubject () {
      return this.API('CompanyRemarkSubjects/GetAllDynamic?select=id,subject as title')
    }
  }
}
</script>
